import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Grid2 as Grid,
  Box,
  Container,
  Stack,
} from "@mui/material";
import { Categories } from "./categories";

export default function FAQGallery() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen sm:mt-32 mt-24">
      <Container sx={{ px: { xs: 2, sm: 6 }, pb: 10 }}>
        <Typography
          variant="h3"
          color="#034272"
          textAlign="center"
          gutterBottom
          sx={{
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
        >
          Frequently Asked Questions
        </Typography>
        <Typography
          variant="subtitle1"
          textAlign="center"
          color="text.secondary"
          mb={6}
          px={2}
        >
          Explore different categories to learn more about Tipkit.
        </Typography>

        {/* Cards Grid */}
        <Grid container spacing={3}>
          {Categories.map((cat) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} item key={cat.id}>
              <Card
                elevation={0}
                onClick={() => {
                  navigate(`/faq/${cat.id}`);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                sx={{
                  px: 2,
                  py: 4,
                  cursor: "pointer",
                  transition: "0.3s ease",
                  borderRadius: 3,
                  boxShadow: `
                  0 0 0 1.2px rgba(0,0,0,0.05), 
                  0 1px 2px rgba(0, 0, 0, 0.15)
                `,
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow:
                      "0 4px 12px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.08)",
                  },
                  "&:hover .iconBox": {
                    transform: "rotatey(180deg)",
                  },
                }}
              >
                {/* Icon */}
                <Box
                  className="iconBox"
                  sx={{
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    borderRadius: 2,
                    mb: 1,
                    transition: "transform 0.5s ease",
                    transformStyle: "preserve-3d",
                  }}
                >
                  {cat.icon}
                </Box>

                {/* Text Content */}
                <CardContent sx={{ p: "0px !important" }}>
                  <Stack direction="column" gap={0.8} pt={1.5}>
                    <Typography
                      fontSize="17px"
                      fontWeight={600}
                      color="#034272"
                      gutterBottom
                    >
                      {cat.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {cat.short}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
